import {buildStateEvent, GenericStateEvent} from '../../common-redux'
import {SupportTeam} from './model'

export interface SupportTeamStateEvent<T> extends GenericStateEvent<T> {}

export const GetAllSupportTeamSuccessEvent = {
    type: 'GetAllSupportTeamSuccessEvent',
    build: (payload: SupportTeam[]) => buildStateEvent(GetAllSupportTeamSuccessEvent.type, payload)
}